import React, { useState } from 'react'
import { setCsvConverterModal } from '../../redux/slice/const'
import { useSelector, useDispatch } from 'react-redux'
import { useDropzone } from 'react-dropzone';
import { DownloadCloud } from 'react-feather';
import {
    Modal,
    Button,
    ModalBody,
    ModalFooter,
    ModalHeader
} from 'reactstrap'
import './styles.scss'

export default function csvConverter() {
    const { csvConverterModal } = useSelector((state) => state.globalConst);
    const { acceptedFiles, getRootProps, getInputProps } = useDropzone();
    const dispatch = useDispatch()

    const files = acceptedFiles.map(file => (
        <li key={file.path}>
            {file.path} - {file.size} bytes
        </li>
    ));

    const toggle = () => {
        dispatch(setCsvConverterModal(!csvConverterModal))
    }

    const csvFileToJSON = (file) => {
        try {
            const reader = new FileReader();
            reader.readAsBinaryString(file);
            reader.onload = function (e) {
                const jsonData = [];
                const headers = [];
                const rows = e.target.result.split("\n");
                for (let i = 0; i < rows.length; i++) {
                    const cells = rows[i].split(",");
                    const rowData = {};
                    for (let j = 0; j < cells.length; j++) {
                        if (i === 0) {
                            const headerName = cells[j].trim();
                            headers.push(headerName);
                        } else {
                            const key = headers[j];
                            if (key) {
                                rowData[key] = cells[j].trim();
                            }
                        }
                    }
                    if (i !== 0) {
                        jsonData.push(rowData);
                    }
                }
            }
        } catch (e) {
            console.error(e);
        }
    }

    const upload = () => {
        if (acceptedFiles[0] === undefined) {
            alert("Selecciona un archivo...");
            return;
        }
        const filename = acceptedFiles[0].name;
        const extension = filename.substring(filename.lastIndexOf(".")).toUpperCase();
        if (extension === '.CSV') {
            //Here calling another method to read CSV file into json
            csvFileToJSON(acceptedFiles[0]);
        } else {
            alert("Selecciona un archivo csv válido.");
        }
    }

    return (
        <div>
            <Modal
                isOpen={csvConverterModal}
                toggle={toggle} className='modal-dialog-centered'>
                <ModalHeader
                    toggle={toggle}
                    className="bg-transparent">
                    Cargar Archivo
                </ModalHeader>
                <ModalBody>
                    <div className=' dropzoneDivContainer'>
                        <div {...getRootProps({ className: 'dropzoneDiv' })}>
                            <input {...getInputProps()} />
                            <DownloadCloud size={54} />
                            <p>Arrastre y suelte o de click para seleccionar un achivo</p>
                        </div>
                    </div>
                    <aside>
                        {/* <h6>Archivo</h6> */}
                        <ul>{files}</ul>
                    </aside>
                </ModalBody>
                <ModalFooter className='d-flex justify-content-between'>
                    <div></div>
                    <Button color='primary' onClick={upload}>Continar</Button>
                </ModalFooter>
            </Modal>
        </div>
    )
}